import { isRequiredSatisfied as isRequiredSatisfiedRule } from './domain/validation';
import { pagedVisibility, phaseRange } from './domain/paging';

export function buildResearchDefenderPayload(
  object,
  text,
  c_text,
  t_page_load,
  t_text_typed,
  t_submit
) {
  const { input_id: q_id, survey_id: sy_nr, visa: sn_ud } = object;
  return JSON.stringify({
    q_id,
    text,
    c_text,
    t_page_load,
    t_text_typed,
    t_submit,
    sn_ud,
    sy_nr,
  });
}

export function getDefaultPhaseRange(self) {
  // Arithmetic lives in the domain layer; this reads the two fields off the
  // widget and passes them in. See `./domain/paging.js` `phaseRange`.
  return phaseRange({
    phase_pos: self._object.phase_pos,
    displaymax: self._object.displaymax,
  });
}

/**
 *
 * `displaymax` counts response options, while the elements being paged are
 * rows holding `columns` options each, so an item range only matches a row
 * range when there is a single column. The layout records which rows belong
 * to which page; prefer that, and fall back to the item range for widgets
 * that page over the response options themselves (cardsort).
 *
 * @param {object} self The widget instance.
 * @param {object} [layout] The widget's DynamicRowLayout instance.
 */
export function getPhaseRange(self, layout) {
  var ranges = layout && layout.groupRowRanges;
  if (!ranges || !ranges.length) {
    return getDefaultPhaseRange(self);
  }

  var range = ranges[self._object.phase_pos] || ranges[ranges.length - 1];
  return { min: range.start, max: range.end };
}

export function getLoadAccessibilityMenuTrigger() {
  return {
    button: {
      keydown: true,
      click: false,
    },
    menu: {
      keydown: true,
      click: true,
      mouseover: true,
    },
  };
}

export function handlePagedVisibility(elems, range) {
  // The domain rule decides which indices show and which hide; the widget then
  // applies that to its elements. See `./domain/paging.js` `pagedVisibility`.
  var visibility = pagedVisibility(elems.length, range);
  visibility.hide.forEach(function (idx) {
    $(elems[idx]).hide();
  });
  visibility.show.forEach(function (idx) {
    $(elems[idx]).show();
  });
}

export function isRequiredSatisfied(self, context = false) {
  if (!context) context = self;
  // Thin wrapper over the domain rule. These callers (Matrix, the Grid
  // displaymax helper) still measure their rows off the DOM, so the counts are
  // passed in rather than derived from the answers snapshot; the HARD/soft
  // decision itself lives in one place now. See `./domain/validation.js`.
  return isRequiredSatisfiedRule(
    context,
    {},
    {
      softPromptsShown: !!self.displaymax_soft_prompts,
      selectedCount: self.selected_rows_count(),
      visibleCount: self.visible_rows_count(),
    }
  );
}

export function resolvePagedElems(self, elems) {
  var resolved = elems || self.$el.find('.dynamic-row');
  return resolved.length === 0 ? null : resolved;
}
